import { useMutation } from "@tanstack/react-query";
import axios from "axios";
import baseUrl from "../../../../utilities/baseUrl";
import LoadingButton from "../../../../components/Loading/LoadingButton";
import Swal from "sweetalert2";
import usePDFDownload from "../../../../hooks/usePDFDownload";

const DownloadReport = ({ state }) => {
  const token = localStorage.getItem("token");

  const { blobToFile } = usePDFDownload();

  const { mutate, isPending } = useMutation({
    mutationKey: ["pdf-report-download"],
    mutationFn: () =>
      axios
        .get(
          `${baseUrl}/totalpost/v1/report?startDate=${state.startDate}&endDate=${state.endDate}&` +
            `numberParcel=${state.numberParcel}&partnumber=${state.partnumber}&componyId=${state.componyId}&` +
            `status=${state.status}&weight=${state.weight}&` +
            `getterName=${state.getterName}&getterProvince=${state.getterProvince}&getterCity=${state.getterCity}&` +
            `senderName=${state.senderName}&senderProvince=${state.senderProvince}&senderCity=${state.senderCity}&shipment_list=${state.selectedValue}&method_payment=${state.method_payment}`,
          {
            headers: {
              Authorization: "Bearer " + token,
            },
            responseType: "blob",
          }
        )
        .then(res => res.data),

    onSuccess: blobToFile,

    onError: async error => {
      let message = "";

      try {
        const object = JSON.parse(await error.response.data.text());
        message = object.message;
      } catch (error) {
        message = "در ارتباط با سرور با خطا مواجه شدیم";
      }

      Swal.fire({
        icon: "error",
        title: message,
        confirmButtonText: "متوجه شدم",
        confirmButtonColor: "red",
      });
    },
  });

  if (isPending) {
    return (
      <LoadingButton
        className="btn-danger fw-bold px-2 m-2"
        center
        title="در حال دانلود"
      />
    );
  }

  return (
    <button className="btn btn-danger fw-bold px-2 m-2" onClick={mutate}>
      دانلود فایل pdf
    </button>
  );
};

export default DownloadReport;
